function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import trackLatexDownloadMenuOpened from 'researcher/helpers/mixpanelEvents';
import { T, useTranslate } from 'shared/helper/translate';
import featureEnabled from 'shared/helper/feature';
import { getDownloadUrl as editingDownloadUrl, searchDigitalEdits } from 'researcher/digital-editing/actions';
import { getDownloadUrl as translationDownloadUrl, searchDigitalOrders } from 'researcher/digital-orders/actions';
import { STATUSES } from 'researcher/digital-editing/constants';
import { TYPE_TRANSLATION } from 'researcher/digital-orders/constants';
import Popover from 'researcher/components/Popover';
import { getApiBaseUrl } from 'shared/helper/request';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
import { RUBRIQ_PLAN_NAMES_MAP, RUBRIQ_LEWIS_VERSION_MAP } from '../constants';
import RubriqDeleteDocumentModal from './RubriqDeleteDocumentModal';
import RubriqDownloadButton from './RubriqDownloadButton';
var RubriqDocumentCardActions = function RubriqDocumentCardActions(_ref) {
  var _curie$plans$premium, _curie$plans, _premium$planName;
  var document = _ref.document,
    status = _ref.status,
    pagination = _ref.pagination,
    _ref$documentType = _ref.documentType,
    documentType = _ref$documentType === void 0 ? 'editing' : _ref$documentType,
    onDownload = _ref.onDownload,
    fileType = _ref.fileType;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    deleteModalOpen = _useState2[0],
    setDeleteModalOpen = _useState2[1];
  var rubriqUpsellDiscountEnabled = featureEnabled('rubriq_upsell_discount');
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector.curie,
    user = _useSelector.user;
  var isTranslation = documentType === 'translation';
  var isAbstract = documentType === 'abstract';
  var showRubriqUpsellDiscount = rubriqUpsellDiscountEnabled && !isTranslation && !isAbstract && (document === null || document === void 0 ? void 0 : document.identity) && document.status === STATUSES.STATUS_COMPLETED;
  var premium = (_curie$plans$premium = curie === null || curie === void 0 || (_curie$plans = curie.plans) === null || _curie$plans === void 0 ? void 0 : _curie$plans.premium) !== null && _curie$plans$premium !== void 0 ? _curie$plans$premium : {};
  var rawPlanName = (_premium$planName = premium.planName) !== null && _premium$planName !== void 0 ? _premium$planName : null;
  var formattedPlanName = RUBRIQ_PLAN_NAMES_MAP[rawPlanName] || rawPlanName;
  if ((premium === null || premium === void 0 ? void 0 : premium.paymentStatus) === 'trialing') {
    formattedPlanName = "".concat(formattedPlanName, " (Trial)");
  }
  var completed = document.status === STATUSES.STATUS_COMPLETED;
  var downloading = status.retrievingDownload && status.downloadingFiles.indexOf(document.identity) >= 0;
  var isLatex = fileType === 'tex';
  var isPdfFailed = document.pdfStatus === 'failed';
  var numberOfResults = pagination.numberOfResults,
    page = pagination.page,
    offset = pagination.offset;
  var dispatch = useDispatch();

  // eslint-disable-next-line no-unused-vars
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    searchParams = _useSearchParams2[0],
    setSearchParams = _useSearchParams2[1];

  // TODO: add delete funcionality and additional services link for translations as well (addressed in a different task)

  var handleDeleteModalClose = function handleDeleteModalClose(result) {
    setDeleteModalOpen(false);
    if (result) {
      var onlyDocumentOnPage = numberOfResults - offset === 1;
      if (onlyDocumentOnPage && page > 1) {
        // move to the previous page since the only document on the current one has just been deleted
        setSearchParams({
          page: page - 1
        });
      } else {
        // just refresh the page we're in
        dispatch(isTranslation ? searchDigitalOrders({
          page: page,
          type: TYPE_TRANSLATION
        }) : searchDigitalEdits({
          page: page
        }));
      }
    }
  };
  var handleDownload = function handleDownload() {
    var _file$name$split$pop, _document$file, _file$name, _file$identity;
    var isPdf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var seconds = moment().diff(moment(document.createdAt), 'seconds');
    var duration = moment.duration(seconds, 'seconds');
    var file = document.file || {};
    var extension = file.name ? (_file$name$split$pop = file.name.split('.').pop()) === null || _file$name$split$pop === void 0 ? void 0 : _file$name$split$pop.toLowerCase() : null;
    var wordcount = ((_document$file = document.file) === null || _document$file === void 0 ? void 0 : _document$file.calculatedWordCount) != null ? Number(document.file.calculatedWordCount) : null;
    var versionKey = RUBRIQ_LEWIS_VERSION_MAP[document.version] || null;
    var editingIntensity = versionKey ? t(versionKey) : null;
    var eventName = isTranslation ? 'Translation Document Downloaded' : 'Edited Document Downloaded';
    var downloadType = isTranslation ? 'translated_file' : isPdf && 'tracked_changes_pdf' || 'edited_file';
    trackRubriqEvent(eventName, {
      time_after_completion: "".concat(Math.floor(duration.asMinutes()), " min ").concat(duration.seconds(), " sec"),
      document_id: document.identity,
      email: user === null || user === void 0 ? void 0 : user.email,
      user_identity: user.identity,
      planName: formattedPlanName !== null && formattedPlanName !== void 0 ? formattedPlanName : null,
      file_name: (_file$name = file.name) !== null && _file$name !== void 0 ? _file$name : null,
      file_type: extension,
      file_identity: (_file$identity = file.identity) !== null && _file$identity !== void 0 ? _file$identity : null,
      wordcount: wordcount,
      editingIntensity: editingIntensity || null,
      styleOfEnglish: document.styleOfEnglish || null,
      language: document.language,
      download_type: downloadType !== null && downloadType !== void 0 ? downloadType : null
    });
    onDownload(document.identity);
    dispatch(isTranslation ? translationDownloadUrl(document.identity, document.file.name) : editingDownloadUrl(document.identity, document.file.name, isPdf));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 mb-3 ms-5"
  }, /*#__PURE__*/React.createElement(RubriqDownloadButton, {
    completed: completed,
    downloading: downloading,
    isLatex: isLatex,
    isPdfFailed: isPdfFailed,
    pdfErrorMessage: document.pdfErrorMessage,
    onDownload: handleDownload,
    onLatexMenuOpened: function onLatexMenuOpened() {
      return trackLatexDownloadMenuOpened(document);
    }
  }), /*#__PURE__*/React.createElement(Popover, {
    content: "curie.delete-file",
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "bottom"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('delete'),
    type: "button",
    className: "not-global btn btn-primary rubriq-ghost-button",
    onClick: function onClick() {
      return setDeleteModalOpen(true);
    },
    disabled: !completed
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-trash-can",
    className: "me-1"
  }))), !isTranslation && !isAbstract && /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(Popover, {
    content: "curie.get-premium-tooltip",
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "bottom"
  }, completed ? /*#__PURE__*/React.createElement("a", {
    "aria-label": t('curie.get-premium'),
    href: "".concat(getApiBaseUrl(), "/api/order-form/from-digital-edit/").concat(document.identity),
    className: "not-global btn btn-primary rubriq-ghost-button"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.get-premium"
  })) : /*#__PURE__*/React.createElement("span", {
    className: "not-global btn btn-primary rubriq-ghost-button disabled"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.get-premium"
  }))), showRubriqUpsellDiscount && /*#__PURE__*/React.createElement(Popover, {
    content: "rubriq-upsell-discount-badge-tooltip",
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "not-global upsell-badge ms-2 px-3 py-2 d-flex align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "upsell-badge-text"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq-upsell-discount-badge"
  }))))))), /*#__PURE__*/React.createElement(RubriqDeleteDocumentModal, {
    open: deleteModalOpen,
    document: document,
    onClose: handleDeleteModalClose,
    isTranslation: isTranslation
  }));
};
export default RubriqDocumentCardActions;